import { __ } from '../utils';
import { Link } from './Link';
import { Button, Card, Stack, Typography } from '@presov.sk/presov-ui-react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import React from 'react';

type Props = {
  message: string;
  caption?: string;
  backUrl?: string;
  backText?: string;
};

const NotFound: React.FC<Props> = ({
  message,
  caption,
  backUrl = '/',
  backText = __('Späť'),
}) => {
  return (
    <Card
      sx={{
        width: '100%',
        p: 2,
      }}
    >
      <Stack alignItems='center' justifyContent='center' gap={2}>
        <ErrorOutlineIcon sx={{ fontSize: 64, color: 'error.main' }} />

        <Stack>
          <Typography variant='h4' textAlign='center'>
            {message}
          </Typography>
          {caption && (
            <Typography color='text.secondary' textAlign='center'>
              {__('Skontrolujte URL adresu alebo sa vráťte na hlavnú stránku.')}
            </Typography>
          )}
        </Stack>
        <Link to={backUrl}>
          <Button color='primary' size='large'>
            {backText}
          </Button>
        </Link>
      </Stack>
    </Card>
  );
};

export default NotFound;
